/* Entrada suave das seções de conteúdo do produto.
 *
 * A classe `hv-js` no <html> é o que ativa o "começa invisível" no CSS. Ela só
 * entra depois de confirmarmos que dá pra revelar — navegador sem
 * IntersectionObserver simplesmente não esconde nada.
 *
 * A rede de segurança de 2,5s existe porque o custo dos dois lados é muito
 * diferente: perder a animação é nada, e conteúdo que nunca aparece é a página
 * de venda em branco. */
(function () {
  var raiz = document.documentElement;
  if (!('IntersectionObserver' in window) || !raiz.classList) return;
  raiz.classList.add('hv-js');

  function revelarTudo() {
    var alvos = document.querySelectorAll('.hv-rv');
    for (var i = 0; i < alvos.length; i++) alvos[i].classList.add('hv-in');
  }

  function iniciar() {
    var alvos = document.querySelectorAll('.hv-rv');
    if (!alvos.length) return;
    var obs = new IntersectionObserver(function (entradas) {
      for (var i = 0; i < entradas.length; i++) {
        if (entradas[i].isIntersecting) {
          entradas[i].target.classList.add('hv-in');
          obs.unobserve(entradas[i].target);
        }
      }
    }, { rootMargin: '0px 0px -8% 0px' });
    for (var i = 0; i < alvos.length; i++) obs.observe(alvos[i]);
    setTimeout(revelarTudo, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
